//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export const BetStatus = {
  IN_GAME: 0,
  WON: 1,
  LOST: 2
};

export default {
  name: 'CrashBet',
  props: {
    bet: {
      type: Object,
      default: null
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    isLg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      BetStatus,
      defaultAvatar: require(`@/assets/images/user/ava_none.jpg`),
    };
  },
  computed: {
    isWonBig() {
      return this.bet?.status === BetStatus.WON && ((this.bet.winningAmount) || 0) > 10;
    },
    isWonSmall() {
      return this.bet?.status === BetStatus.WON && ((this.bet.winningAmount) || 0) <= 10;
    },
    ratio() {
      return this.bet?.stoppedAt || 0;
    },
    formattedRatio() {
      return `x${Number(this.ratio).toFixed(2)}`;
    },
    cardClasses() {
      if (!this.bet) return {};
      return {
        'bg-dark-250': this.bet.status === BetStatus.IN_GAME,
        'bg-dark-300': this.bet.status === BetStatus.LOST || this.isWonSmall,
        'is-won-big': this.isWonBig,
        'border-highlight': this.bet.isSpectator && this.bet.status !== BetStatus.WON,
        'border-highlight-won': this.bet.isSpectator && this.bet.status === BetStatus.WON
      };
    },
    ratioClasses() {
      if (!this.bet) return {};
      return {
        'ratio-won-big': this.isWonBig,
        'ratio-won-small': this.isWonSmall,
        'ratio-lost': this.bet.status === BetStatus.LOST,
        'ratio-in-game': this.bet.status === BetStatus.IN_GAME
      };
    }
  },
  methods: {
    setSpectatorBet(betId) {
      this.$emit('spectate', betId);
    },
    getAvatar(url) {
      return url || this.defaultAvatar;
    },
    getStaticUrl(path) {
      return path;
    },
    getItemImage(item) {
      return item?.itemPic || '';
    }
  }
};
